export default {"src":"/_next/static/media/face_not_verified.d9a3e370.svg","height":130,"width":160,"blurWidth":0,"blurHeight":0};